module.exports = __webpack_public_path__ + "img/applied.97ba4a81.svg";